import NProgress from 'react-nprogress'

const updateProgress = (before, after) => {
  if (after === 1 && before === 0) return NProgress.start()
  if (after === 0) return NProgress.done()

  // max - current * (% complete)
  let changePercent = (before - after) / before
  let current = NProgress.status

  if (changePercent > 0) return NProgress.inc((1 - current) * changePercent)
  if (changePercent < 0) return NProgress.inc(current * changePercent)

  return NProgress.inc() // fallback to a random increment
}

// Action Handlers
const ACTION_HANDLERS = {
  API_REQUEST: (state, action) => {
    let fetching = state.fetching + 1
    if (fetching <= 1) fetching = 1

    updateProgress(state.fetching, fetching)

    return Object.assign({}, state, {
      fetching
    })
  },
  API_SUCCESS: (state, action) => {
    let fetching = state.fetching - 1
    if (fetching <= 0) fetching = 0

    updateProgress(state.fetching, fetching)

    return Object.assign({}, state, {
      fetching
    })
  },
  API_FAILURE: (state, action) => {
    let fetching = state.fetching - 1
    if (fetching <= 0) fetching = 0

    updateProgress(state.fetching, fetching)

    return Object.assign({}, state, {
      fetching,
      error: action.associated && action.associated.error
    })
  }
}

// Reducer
const initialState = {
  fetching: 0,
  error: null
}

export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/api.js